<template>
  <div class="carrier_content">
    <span class="title">
      客户服务商
    </span>
    <span :class="{'carrier':true,'noClick':forbidden}" @click="handleCutCarrier">
      {{`${carrier.tenantName||'--'} - ${carrier.customerName||'--'}`}}
    </span>
  <carriersSelectDialog ref="SelectDialog" @select="handleSelect"></carriersSelectDialog>
  </div>
</template>

<script>
import { EventBus } from '@/utils/event-bus'
import carriersSelectDialog from './carriersSelectDialog.vue'

  export default {
    name:'CutCarrier',
    components:{
      carriersSelectDialog
    },
    data(){
      return {
        carrier:{},
        forbidden:false
      }
    },
    created(){
      const {customerName,tenantName,customers}=this.$store.state.user
      this.carrier={customerName,tenantName}
      const isEdit=!!this.$route.query.odrNo
      if(customers.length===1||isEdit){
        this.forbidden=true
      }
    },
    methods:{
       handleSelect(select){
        EventBus.$emit('handleSelect',select)
      },
      handleCutCarrier(){
        if(this.forbidden)return
        this.$refs.SelectDialog.init(this.$store.state.user.customerId)
      }
    }
  }
</script>

<style lang="less" scoped>
.carrier_content {
  .carrier {
    text-decoration:underline;
    color: #06B880;
    cursor: pointer;
    margin-left: 10px;
  }
  .noClick{
    color: #ccc;
    cursor:not-allowed;
    margin-left: 10px;
  }
}

</style>